import React, { useState } from "react"
import CommonTablePage, { CommonTablePagePropsInterface } from '../../../components/common/common-table/common-table-page'
import ProductionMaintenanceLogColumnModel from './maintenance-log-model'
import { urlKey } from '../../../services/api/api-urls'
import { ApiRequest } from '../../../services/api/api'
import { useDocumentTitle } from '../../../services/title/useDocumentTitle'
import MaintenanceLogDialog from './maintenance-log-dialog'
import MaintenanceLogEditDialog from './maintenance-log-edit-dialog'
import CommonDialog from '../../../components/common/others/common-dialog'
import { getRandomKey } from '../../../services/lib/utils/helpers'
import SweetAlertService from '../../../services/lib/utils/sweet-alert-service'

const ProductionMaintenanceLogPage: any = (props: any) => {
  useDocumentTitle()
  const [open, setOpen] = useState(false)
  const [editingLog, setEditingLog] = useState<any>(null)
  const [triggerResetData, setTriggerResetData] = useState<any>(false)

  const onDialogClose = (success: boolean) => {
    setOpen(false)
    if (success) {
      setTriggerResetData(getRandomKey())
    }
  }

  const onEditDialogClose = (success: boolean) => {
    setEditingLog(null)
    if (success) {
      setTriggerResetData(getRandomKey())
    }
  }

  const actionButtons: any = [
    {
      icon: 'ghost',
      tooltip: 'Add New Log',
      isFreeAction: true,
      onClick: () => setOpen(true),
    },
    {
      icon: '',
      tooltip: 'Edit',
      isFreeAction: false,
      onClick: (event: any, rowData: any) => setEditingLog(rowData),
    },
    {
      icon: 'ghost',
      tooltip: 'Delete',
      isFreeAction: false,
      onClick: async (event: any, rowData: any) => {
        const resultInput = await SweetAlertService.warningConfirm1('Maintenance Log', 'Deletion is irreversible');
        if (resultInput.dismissed) return;
        await ApiRequest({
          url: 'Maintenance/DeleteLog?id=' + rowData.maintenanceLogId,
          method: 'delete',
          isShowSpinner: true,
        })
        SweetAlertService.successMessage('Deleted successfully')
        setTriggerResetData(getRandomKey())
      },
    },
  ]

  const commonTablePageProps: CommonTablePagePropsInterface = {
    urlInfoKey: urlKey.MaintenanceLog,
    title: props.title || 'Production Maintenance Log',
    column: ProductionMaintenanceLogColumnModel(),
    isNotDeletable: true,
    isNotAddable: true,
    isNotEditable: true,
    triggerResetData: triggerResetData,
    actionButtons: actionButtons,
    mappingRenderData: (data: any[]) =>
      [...(data || [])].sort((a, b) => {
        const dateA = a.date ? new Date(a.date).getTime() : 0
        const dateB = b.date ? new Date(b.date).getTime() : 0
        return dateB - dateA
      }),
  }

  return (
    <div>
      <CommonTablePage {...commonTablePageProps} />
      <CommonDialog
        title="Add New Maintenance Log 新增维修记录"
        open={open}
        onDialogClose={onDialogClose}
        dialogContent={<MaintenanceLogDialog onDialogClose={onDialogClose} />}
        width="700px"
      />
      <CommonDialog
        title="Edit Maintenance Log"
        open={!!editingLog}
        onDialogClose={onEditDialogClose}
        dialogContent={editingLog ? <MaintenanceLogEditDialog logData={editingLog} onDialogClose={onEditDialogClose} /> : null}
        width="700px"
      />
    </div>
  )
}

export default ProductionMaintenanceLogPage
